export default "__VITE_ASSET__Dil2ay5K__"